export const NEWS=[{date:"2026-10-19",title:"오늘·달력·고객·내 페이지로 예약실을 나눴어요",body:"쓰던 예약과 고객 기록은 그대로예요. 장부 CSV의 열을 직접 짝짓고, 예약 규칙·회원권 기록·전체 ZIP 내보내기를 사용할 수 있어요. 자동 결제나 광고는 열지 않았어요."}];
